module.exports = __webpack_public_path__ + "static/c5-04b3d5eaefc4937d99c9022d7829b876.jpeg";